import { all, fork } from "redux-saga/effects";

import loginSaga from "../components/LoginForm/login.sagas";
import booksaga from "../components/Book/book.sagas";
import contributorsaga from "../components/Contributor/contributor.sagas";

export function* rootSaga() {
    yield all([fork(loginSaga),fork(booksaga),fork(contributorsaga)]);
  }
